<script>
import { ref, toRef } from 'vue'

export default {
  props: {
    active: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup(props, { slots }) {
    const initialA  = toRef(props, 'active')
    const active    = ref(initialA.value)
    const grid      = ref(true)
    const toggle    = (payload) => {
      active.value = payload
      window.scrollTo(0, 0)
    }
    const toggleGrid = (payload) => {
      grid.value = payload
    }

    window.addEventListener( 'resize', function() {
      let winW = window.innerWidth
      if ( winW < 768 ) {
        grid.value = true
      }
    }, false)

    return () => slots.default({
      active: active.value,
      grid: grid.value,
      toggle,
      toggleGrid
    })
  }
}
</script>